const en = {
  生活用品: 'Daily necessities',
  期待送达方式: 'Expected delivery method',
  '计费重量(KG)': 'Billing weight (KG)',
  基础运费: 'Basic shipping fee',
  优惠费用: 'Discount fee',
  总计: 'Total',
  寄快递: 'create shipment',
  物品信息: 'Parcel info',
  签名: 'Sign',
  预览: 'Preview',
  条款与条件: 'Conditions and terms',
  寄件人信息: 'Sender info',
  收件人信息: 'Receiver info',
  下单成功: 'checkout success',
  寄件人: 'Sender',
  点击填写寄件人信息: 'Click to fill sender info',
  收件人: 'Receiver',
  点击填写收件人信息: 'Click to fill in shipper info',
  物品价值: 'Goods Value',
  保价费: 'Insurance Fee',
  快递公司: 'Express company',
  扫码下单: 'Scan the code to place an order',
  期望送达方式: 'Expected delivery method',
  上门派送: 'Door-to-door delivery',
  驿站自提: 'Self-pickup at station',
  无要求: 'No requirements',
  快件类型: 'Parcel Type',
  '我已阅读，理解并同意': 'I have read, understand and areed to the',
  合计: 'Total',
  明细: 'Detail',
  下单: 'submit',
  费用明细: 'Fee details',
  运费: 'Shipment fee',
  下载: 'Download',
  请输入寄件人姓名: 'Please enter sender name',
  请选择所在地区: 'Please select district',
  请输入寄件人详细地址: 'Please enter sender detailed address',
  请输入寄件人手机号码: 'Please enter sender mobile number',
  请输入收件人姓名: 'Please enter the recipient name',
  请输入收件人详细地址: 'Please enter the recipient detailed address',
  请输入收件人手机号码: 'Please enter recipient phone number',
  物品价值不能为空: 'Item value cannot be empty',
  '没有签名信息，无法保存': 'No signature information, unable to save',
  未获取到报价: 'No quote was obtained',
  '是否确定下单？': 'Are you sure to place an order?',
  确定: 'OK',
  取消: 'Cancel',
  请输入手机或固定电话: 'Please enter mobile or telephone',
  请输入邮箱: 'Please input email address',
  清空当前信息: 'Clear current information',
  请输入10位手机号: 'Please enter a 10 digits phone number',
  物品类型: 'Item type',
  违禁物品清单: 'List of prohibited items',
  重量: 'Weight',
  数量: 'Quantity',
  物品类别: 'Item type',
  袋子规格: 'Pouch Size',
  文件: 'file',
  数码产品: 'digital product',
  食品: 'food',
  服装: 'clothes',
  其他: 'Others',
  不需要袋子: 'No need for Pouch',
  小: 'Small',
  中: 'Middle',
  大: 'Large',
  加载中: 'Loading',
  保存成功: 'Successfully saved',
  '请确认已保存二维码图片?':
    'Please confirm that the QR code image has been saved?',
  '请出示二维码给站点人员，进行扫描下单':
    'Please show the QR code to the site staff for scanning and placing the order',
  订单编号: 'Order number',
  订单号: 'Order number',
  没有更多了: 'No more',
  暂无数据: 'No data',
  清空: 'Empty',
  新用户首单寄免费: 'New Customer free to shipping',
  优惠类型: 'Discount type',
  优惠金额: 'Discount amount',
  '退出后将不享受新用户首单免费寄，是否确认？':
    'After logging out, new users will no longer enjoy free shipping for their first order. Still want to exit?',
  输入验证码: 'Please enter verification code',
  请输入图形验证码: 'Please enter the captcha',
  获取验证码: 'Verification code',
  新用户首单需获取短信验证码校验即可享受免费寄:
    'New users need to obtain an SMS verification code for their first order to enjoy free shipping',
  验证码错误或过期: 'Incor or expired verification code ncor',
  '参数无效:运费为0,请联系管理员':
    'Shipping fee is 0, please contact the administrator',
  '参数无效:物品重量不能超出50kg': 'The weight of the item cannot exceed 50kg',
  Super增值费: 'Super Fee',
  航空违禁品: 'Aviation prohibited items',
  不可抗力规则描述: 'Unforeseen circumstances rules',
  '当前选择Small包裹,重量应在3kg以下':
    'Current selection is Small pouch,\n weight should be below 3kg',
  '当前选择Medium包裹,重量应在5kg以下':
    'Current selection is Medium pouch,\n  weight should be below 5kg',
  '当前选择Large包裹,重量应在8kg以下':
    'Current selection is Large pouch,\n  weight should be below 8kg',
  super件重量不能超过5kg: 'Super parcel weight cannot exceed 5kg',
  'Home Delivery': 'Home Delivery',
  PARCEL: 'PARCEL',
  'Item type': 'Item type',
  'Express company': 'Express company',
  'Goods Value': 'Goods Value',
  'Insurance Fee': 'Insurance Fee',
  'Super Fee': 'Super Fee',
  继续下单: 'Continue to place order'
}

export default en
